import { Flex, Text } from "@chakra-ui/react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
// import { useMemo } from "react";
import Modal from "components/UI/organisms/Modal"
import { useUI } from "providers/UIProvider";
import "./styles.scss"
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider";


const MyGoogleMapsModal = () => {
    const { modals, toggleModal } = useUI()
    const { changesHistory } = useLaundryContext()
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
    });
    const filteredChangesHistory = changesHistory.filter((item: any) => item?.type === 9);
    const latitude = Number(filteredChangesHistory.map((item: any) => item?.oldValue?.split(" ")[0]))
    const longitude = Number(filteredChangesHistory.map((item: any) => item?.oldValue?.split(" ")[1]))


    // const center = useMemo(() => ({ lat: latitude, lng: longitude }), [laundry]);
    return (
        <Modal
            isOpen={modals.myGoogleMapsModal.isOpened}
            onClose={() => toggleModal("myGoogleMapsModal", false)}
            styles={{
                headerPadding: "20px 15px 20px 23px",
                width: "700px",
                bodyPadding: "25px 25px 48px 25px",
            }}
        >
            <Flex style={{ height: "415px", width: "100%" }}>
                {!isLoaded ? (
                    <Text>Loading...</Text>
                ) : (
                    <GoogleMap
                        mapContainerClassName="map-container"
                        center={{ lat: latitude, lng: longitude }}
                        zoom={15}
                    >
                        <Marker position={{ lat: latitude, lng: longitude }} />
                    </GoogleMap>
                )}
            </Flex>
        </Modal>
    );
};

export default MyGoogleMapsModal;